<div class="user-account-sidebar-overlay" *ngIf="isOpen" (click)="closeSidebar()"></div>

<div class="user-account-sidebar" [class.open]="isOpen">
  <div class="sidebar-header">
    <button class="close-button" (click)="closeSidebar()" nbButton ghost>
      <nb-icon icon="chevron-right-outline"></nb-icon>
    </button>
    <h6>{{ 'tytul.moje-konto' | translate }}</h6>
  </div>

  <div class="sidebar-content">
    <!-- Język -->
    <div class="menu-item">
      <div class="menu-item-header">
        <nb-icon icon="globe-outline"></nb-icon>
        <span>{{ 'etykieta.jezyk' | translate }}</span>
      </div>
      <div class="language-selector">
        <button 
          *ngFor="let lang of availableLanguages" 
          (click)="changeLanguage(lang.code)"
          [class.active]="getCurrentLanguage() === lang.code"
          class="language-button"
          nbButton ghost size="small">
          <i [class]="'flag-icon ' + lang.flag"></i>
          {{ lang.name }}
        </button>
      </div>
    </div>

    <!-- Dane firmy -->
    <div class="menu-item" *ngIf="klient">
      <div class="menu-item-header">
        <nb-icon icon="briefcase-outline"></nb-icon>
        <span>{{ 'etykieta.dane-firmy' | translate }}</span>
      </div>
      <div class="company-data">
        <div *ngIf="klient.nazwa" class="company-name">{{ klient.nazwa }}</div>
        <div class="company-details">
          <small>{{ 'etykieta.nip' | translate }}: {{ getNip() }}</small><br>
          <small>{{ 'etykieta.regon' | translate }}: {{ getRegon() }}</small>
        </div>
      </div>
    </div>

    <!-- Zmień klienta -->
    <div class="menu-item" *ngIf="klienciAlternatywni && klienciAlternatywni.length > 0">
      <div class="menu-item-header client-selector">
        <ngx-wybor-klienta [klienci]="klienciAlternatywni"></ngx-wybor-klienta>
      </div>
    </div>

    <div class="menu-item menu-item-clickable" (click)="loginToSaldeo()">
      <div class="menu-item-header">
        <nb-icon icon="external-link-outline"></nb-icon>
        <span>{{ 'akcja.saldeo-dodaj-dokument' | translate }}</span>
      </div>
    </div>

    <div class="menu-item menu-item-clickable" (click)="loginToSaldeo()">
      <div class="menu-item-header">
        <nb-icon icon="external-link-outline"></nb-icon>
        <span>{{ 'akcja.saldeo-wystaw-fakture' | translate }}</span>
      </div>
    </div>

    <!-- Wyślij wiadomość -->
    <div class="menu-item menu-item-clickable" (click)="openMessageDialog()">
      <div class="menu-item-header">
        <nb-icon icon="email-outline"></nb-icon>
        <span>{{ 'etykieta.kontakt' | translate }}</span>
      </div>
    </div>

    <!-- Dokumenty 2+1 -->
    <div class="menu-item menu-item-clickable" *ngIf="maDokumentyPortalowe" (click)="openDokumentyPortalowe()">
      <div class="menu-item-header">
        <nb-icon icon="file-text-outline"></nb-icon>
        <span>{{ 'etykieta.dokumenty-2-plus-1' | translate }}</span>
      </div>
    </div>

    <!-- Zmień hasło -->
    <div class="menu-item menu-item-clickable" (click)="changePassword()">
      <div class="menu-item-header">
        <nb-icon icon="lock-outline"></nb-icon>
        <span>{{ 'etykieta.zmien-haslo' | translate }}</span>
      </div>
    </div>

    <!-- Wyloguj -->
    <div class="menu-item menu-item-clickable menu-item-danger" (click)="logout()">
      <div class="menu-item-header">
        <nb-icon icon="power-outline"></nb-icon>
        <span>{{ 'etykieta.wyloguj' | translate }}</span>
      </div>
    </div>
  </div>
</div>